export default __webpack_public_path__ + "static/media/bb1.7e7b872d.png";